import React from "react";

// Format a date string like "25 February 2026"
function formatElegantDate(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

// Detect URLs in text and wrap them in anchor tags
function renderContentWithLinks(text) {
  if (!text) return null;
  // Match URLs starting with http/https
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // Reset regex lastIndex since it's stateful with /g
      urlRegex.lastIndex = 0;
      return (
        <a key={index} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    return <span key={index}>{part}</span>;
  });
}

function LetterCard({ message, isOwnMessage }) {
  const senderInitial = message.sender_name
    ? message.sender_name.charAt(0).toUpperCase()
    : "?";

  const isWarning = message.message_type === "warning";
  const isAppeal = message.message_type === "appeal";

  return (
    <div className={`letter-card ${isWarning ? "border-l-4 border-l-amber-500" : ""} ${isAppeal ? "border-l-4 border-l-teal-500" : ""}`}>
      {/* Special message badge */}
      {isWarning && (
        <div className="mb-[8px]">
          <span className="text-[11px] font-bold px-[8px] py-[2px] rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300">
            Admin Notice
          </span>
        </div>
      )}
      {isAppeal && (
        <div className="mb-[8px]">
          <span className="text-[11px] font-bold px-[8px] py-[2px] rounded-full bg-teal-100 dark:bg-teal-900/30 text-teal-800 dark:text-teal-300">
            Appeal
          </span>
        </div>
      )}

      {/* Header: sender info and date */}
      <div className="letter-header">
        <div className="flex flex-row items-center gap-x-[12px]">
          <div className={`wax-seal wax-seal-small`}>{senderInitial}</div>
          <div className="flex flex-col">
            <span className="letter-sender">{message.sender_name}</span>
            {isOwnMessage && (
              <span className="text-[13px] font-body text-dupontGray dark:text-darkTextSecondary italic">
                (You)
              </span>
            )}
          </div>
        </div>
        <span className="letter-date">{formatElegantDate(message.created_at)}</span>
      </div>

      {/* Message body */}
      <div className="letter-body">
        {renderContentWithLinks(message.content)}
      </div>

      {/* Media attachment (image or GIF in a gold frame) */}
      {message.media_url && (
        <div className="letter-media-frame">
          <img src={message.media_url} alt="Attached" />
        </div>
      )}
    </div>
  );
}

export default LetterCard;
